export const SET_QUIZ_MODE = 'SET_QUIZ_MODE'
export const SET_GUESS_MODE = 'SET_GUESS_MODE'
export const SET_GUESS_OPTIONS = 'SET_GUESS_OPTIONS'
export const SET_GUESS_OPTION_SELECTED = 'SET_GUESS_OPTION_SELECTED'
export const SET_GUESS_ANSWER = 'SET_GUESS_ANSWER'
export const SET_GUESS_KEY = 'SET_GUESS_KEY'
export const SET_GUESSER_NAME = 'SET_GUESSER_NAME'
